import React from "react";
import { Link, useLocation } from "react-router-dom";
import { SITE_ORIGIN } from "../data/site";
type SiteLinkProps = {
  path: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
};
export function SiteLink({
  path,
  className,
  children,
  onClick
}: SiteLinkProps) {
  const location = useLocation();
  if (path.startsWith("/#") && location.pathname === "/") {
    return <a href={path.slice(1)} className={className} onClick={onClick} data-id="element-304" data-mp="3gr8s77p3yvi">{children}</a>;
  }
  if (path === "/" || path.startsWith("/#") || path === "/cases" || path.startsWith("/cases/")) {
    return <Link to={path} className={className} onClick={onClick} data-id="element-305" data-mp="3qm8guvkeoun3">{children}</Link>;
  }
  return <a href={`${SITE_ORIGIN}${path}`} target="_blank" rel="noopener" className={className} onClick={onClick} data-id="element-306" data-mp="3vka8w5zt84ap">
      {children}<span className="sr-only" data-id="element-307" data-mp="2f5iejnj3smyr"> (opens in a new tab)</span>
    </a>;
}